import apiClient from './client';

export interface ChangeOrderItem {
  id?: number;
  description: string;
  quantity: number;
  unit_price: number;
  total?: number;
}

export interface ChangeOrder {
  id: number;
  job_id: number;
  change_order_number: string;
  title: string;
  description?: string;
  status: 'draft' | 'sent' | 'approved' | 'declined';
  subtotal: number;
  tax_rate: number;
  tax_amount: number;
  total: number;
  approval_token?: string;
  approved_at?: string;
  approved_by_name?: string;
  created_at: string;
  items: ChangeOrderItem[];
}

export const getChangeOrders = async (jobId: number): Promise<ChangeOrder[]> => {
  const { data } = await apiClient.get(`/change-orders/job/${jobId}`);
  return data.data;
};

export const createChangeOrder = async (jobId: number, payload: Partial<ChangeOrder>): Promise<ChangeOrder> => {
  const { data } = await apiClient.post(`/change-orders/job/${jobId}`, payload);
  return data.data;
};

export const updateChangeOrder = async (id: number, payload: Partial<ChangeOrder>): Promise<void> => {
  await apiClient.put(`/change-orders/${id}`, payload);
};

export const deleteChangeOrder = async (id: number): Promise<void> => {
  await apiClient.delete(`/change-orders/${id}`);
};

export const sendChangeOrder = async (id: number): Promise<{ approveUrl: string }> => {
  const { data } = await apiClient.post(`/change-orders/${id}/send`);
  return data.data;
};

export const approveChangeOrderByToken = async (
  token: string,
  approvedByName: string
): Promise<void> => {
  await apiClient.post(`/change-orders/approve/${token}`, { name: approvedByName });
};

// Admin approve a change order directly (no token required)
export const approveChangeOrder = async (id: number, name?: string): Promise<void> => {
  await apiClient.post(`/change-orders/${id}/approve`, name ? { name } : {});
};

// Admin decline a change order
export const declineChangeOrder = async (id: number): Promise<void> => {
  await apiClient.post(`/change-orders/${id}/decline`);
};
